// After an update the service worker can still hold the previous release's app-config.json, so the update banner asks
// the next start to fetch the config from the network (see main.ts). Normal starts keep using the cached copy.
const FRESH_CONFIG_KEY = 'td-fresh-config';

export function requestFreshConfig(storage: Storage = sessionStorage) {
    try {
        storage.setItem(FRESH_CONFIG_KEY, '1');
    } catch {
        // storage blocked (private mode): the next start uses the cached config as before
    }
}

export function takeFreshConfigRequest(storage: Storage = sessionStorage): boolean {
    try {
        const requested = storage.getItem(FRESH_CONFIG_KEY) === '1';
        storage.removeItem(FRESH_CONFIG_KEY);
        return requested;
    } catch {
        return false;
    }
}

export async function fetchConfig(fresh: boolean, fetchFn: typeof fetch = fetch): Promise<Response> {
    if (fresh) {
        try {
            const res = await fetchFn('app-config.json?ngsw-bypass=true', { cache: 'no-store' });
            if (res.ok) {
                // also refresh the service worker's copy for the next start
                fetchFn('app-config.json').catch(() => undefined);
                return res;
            }
        } catch {
            // offline right after the update: fall back to the cached config
        }
    }

    return fetchFn('app-config.json');
}
